/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateQueue.defs.js'
export { main as default } from './updateQueue.defs.js'
